import { RefObject, useCallback } from 'react';
import { useHeaderResizeListener } from 'src/commons/utils/hooks';

export default (pageHeaderRef: RefObject<HTMLDivElement>): void => {
  const callback = useCallback((e: Event) => {
    const customEvent = e as CustomEvent;
    if (pageHeaderRef.current) {
      pageHeaderRef.current.style.marginTop = `${customEvent.detail.headerHeight}px`;
    }
  }, []);

  useHeaderResizeListener({ callback });
};
